import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {Card} from '../../../_models/card.model';
import {CrisisAlertService} from '../../services/crisis-alert.service';

@Component({
  selector: 'app-dashboard-carousel',
  templateUrl: './dashboard-carousel.component.html',
  styleUrls: ['./dashboard-carousel.component.scss'],
})
export class DashboardCarouselComponent implements OnInit {

  listTrigger: Observable<string>;
  cards: Observable<Card[]>;
  chunkSize = 4;
  showControls = false;
  dataItemWidth: number;
  coverWidth: number;

  constructor(private crisisAlertService: CrisisAlertService) {
  }

  ngOnInit() {
    let cardsCount = Math.floor((window.innerWidth - 200) / 200);
    if (cardsCount === 0) {
      cardsCount = 1;
    }
    this.chunkSize = cardsCount;
    this.dataItemWidth = (cardsCount * 200);
    this.coverWidth = this.dataItemWidth + 110;
    this.cards = this.crisisAlertService.cardsObs;
    this.listTrigger = this.crisisAlertService.listTriggerObs;
  }

}
